import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import SelectBox from "../../../../components/SelectBox";
import { isFieldDisabled } from "../../../../utils/validators";
import { useAxiosWithAuthorization } from "../../../../utils/api";
import useAppContext from "../../../../utils/Reducers";

const GradViewPop = ({ inspData }) => {
  //차량 검색 URL
  //공통코드 검색 URL

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [menuTab, setMenuTab] = useState("grade");
  const [show1, setShow1] = useState(true);
  const [hide, setHide] = useState(false);
  const handleClose = (returnData) => {
    setShow1(false);
  };

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const [state, setState] = useState("normaled");

  const [fieldValues, setFieldValues] = useState(inspData);

  const onHide = () => {
    setHide(!hide);
  };

  const onMenuTab = (menuNm) => {
    setMenuTab(menuNm);
  };
  return (
    <>
      <Modal
        className="modal-fullscreen-md-down ims orenges"
        show={show1}
        id="view"
        onHide={() => handleClose(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {inspData.inspNo === "" || inspData.inspNo === null
              ? inspData.wssId
              : inspData.inspNo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={hide ? "infotype on" : "infotype"} onClick={onHide}>
            <div>
              <div className="micon trans">
                <div></div>
                <p>차량번호</p>
              </div>
              <div className="inf">
                <div>
                  <h3>
                    {fieldValues.vhclNo} / {fieldValues.plantNm}
                  </h3>
                </div>
              </div>
            </div>
            <div>
              <div className="micon box">
                <div></div>
                <p>입차중량</p>
              </div>
              <div className="inf">
                <div>
                  <h3>{fieldValues.totalWeight}kg</h3>
                </div>
              </div>
            </div>

            <div>
              <div className="micon time">
                <div></div>
                <p>입차일시</p>
              </div>
              <div className="inf">
                <div>
                  <h3>{fieldValues.wghtDt}</h3>
                </div>
              </div>
            </div>
          </div>

          <ul className="mlist">
            <li className="head">
              <div>사전등급</div>
            </li>
            <li>
              <div>{fieldValues.transCdNm}</div>
            </li>
            <li>
              <div>{fieldValues.itemNm}</div>
            </li>

            <li className="head">
              <div>차량정보</div>
            </li>
            <li>
              <div>{fieldValues.vhclNo}</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.vhclTypeNm}</div>
              </div>
            </li>

            <li className="head">
              <div>업체정보</div>
            </li>
            <li>
              <div>{fieldValues.vndrNm}</div>
            </li>
            <li>
              <div>{fieldValues.rvndrNm}</div>
            </li>

            <li className="head">
              <div>하차지</div>
            </li>
            <li className="fullsc">
              <div>
                <div>{fieldValues.scrapAreaCdNm}</div>
              </div>
            </li>

            <li className="head">
              <div>검수등급</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.dcsnItemNm}</div>
              </div>
            </li>
            <li>
              <div>{fieldValues.workerNm}</div>
            </li>
          </ul>
          <ul className="mlist quad">
            <li className="fullhead">
              <div>등급 별 품목/비율 입력</div>
            </li>

            <li className="head">
              <div>등급 01</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemNm1}</div>
              </div>
            </li>
            <li>
              <div>
                <div
                  style={{
                    width: "90px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    wordBreak: "break-all",
                  }}
                >
                  {fieldValues.subItemPrdNm1}
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemRateNm1}</div>
              </div>
            </li>

            <li className="head">
              <div>등급 02</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemNm2}</div>
              </div>
            </li>
            <li>
              <div>
                <div
                  style={{
                    width: "90px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    wordBreak: "break-all",
                  }}
                >
                  {fieldValues.subItemPrdNm2}
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemRateNm2}</div>
              </div>
            </li>

            <li className="head">
              <div>등급 03</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemNm3}</div>
              </div>
            </li>
            <li>
              <div>
                <div
                  style={{
                    width: "90px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    wordBreak: "break-all",
                  }}
                >
                  {fieldValues.subItemPrdNm3}
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.subItemRateNm3}</div>
              </div>
            </li>
          </ul>
          <ul className="mlist">
            <li className="fullhead">
              <div>감량 반품 경고 감가</div>
            </li>

            <li className="head">
              <div>감량</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.outageWght}</div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.outageRsnNm}</div>
              </div>
            </li>

            <li className="head">
              <div>반품/경고</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.returnCdNm}</div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.returnRsnNm}</div>
              </div>
            </li>

            <li className="head">
              <div>감가</div>
            </li>
            <li>
              <div>
                <div>{fieldValues.dprctRateNm}</div>
              </div>
            </li>
            <li>
              <div>
                <div>{fieldValues.dprctCdNm}</div>
              </div>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const ModalGradViewPop = createModal(GradViewPop);

export default GradViewPop;
